/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Issue_Statement_Empty_PlInputs */

const en_statement_taxonomy_issue_statement_empty_pl = /** @type {(inputs: Statement_Taxonomy_Issue_Statement_Empty_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one profit & loss row`)
};

const nl_statement_taxonomy_issue_statement_empty_pl = /** @type {(inputs: Statement_Taxonomy_Issue_Statement_Empty_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg minstens één W&V-regel toe`)
};

/**
* | output |
* | --- |
* | "Add at least one profit & loss row" |
*
* @param {Statement_Taxonomy_Issue_Statement_Empty_PlInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_issue_statement_empty_pl = /** @type {((inputs?: Statement_Taxonomy_Issue_Statement_Empty_PlInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Issue_Statement_Empty_PlInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_issue_statement_empty_pl(inputs)
	return en_statement_taxonomy_issue_statement_empty_pl(inputs)
});